import { render, staticRenderFns } from "./CouponAlert.vue?vue&type=template&id=0f3abf64&scoped=true"
import script from "./CouponAlert.vue?vue&type=script&lang=js"
export * from "./CouponAlert.vue?vue&type=script&lang=js"
import style0 from "./CouponAlert.vue?vue&type=style&index=0&id=0f3abf64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3abf64",
  null
  
)

export default component.exports